import { BaseApiService } from '@/services/base-service';
import {
  PurchaseOrderRequest,
  PurchaseOrderResponse,
  PurchaseOrderUpdateResponse,
  PurchaseOrderTableResponse,
  EquipmentRequest,
  EquipmentResponse,
  FilesRequest,
  FilesResponse,
  FileResponse,
  PurchaseOrders,
} from '../types';

export class PurchaseOrdersService extends BaseApiService {
  private readonly base_path = 'purchase-orders';
  private readonly equipment_path = 'equipment';
  private readonly files_path = 'files';

  async get_purchase_orders(filters: PurchaseOrderRequest): Promise<PurchaseOrderTableResponse> {
    const payload = filters;

    const { data } = await this.http_client.get<PurchaseOrderTableResponse>(this.base_path, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_purchase_order(id: string | number): Promise<PurchaseOrderResponse> {
    const url = `${this.base_path}/${id}`;
    const { data } = await this.http_client.get<PurchaseOrderResponse>(url);

    return data;
  }

  async update_purchase_order(payload: PurchaseOrders.UpdatePurchaseOrderPayload): Promise<PurchaseOrderUpdateResponse> {
    const url = `${this.base_path}/${payload.id}`;

    const { data } = await this.http_client.patch<PurchaseOrderUpdateResponse>(url, payload);

    return data;
  }

  async get_equipment(id: string | number, filters: EquipmentRequest): Promise<EquipmentResponse> {
    const payload = filters;

    const url = `${this.base_path}/${id}/${this.equipment_path}`;
    const { data } = await this.http_client.get<EquipmentResponse>(url, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_files(id: string | number, filters: FilesRequest): Promise<FilesResponse> {
    const payload = filters;

    const url = `${this.base_path}/${id}/${this.files_path}`;
    const { data } = await this.http_client.get<FilesResponse>(url, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async add_file(id: string | number, form_data: FormData): Promise<FileResponse> {
    const url = `${this.base_path}/${id}/${this.files_path}`;

    const { data } = await this.http_client.post<FileResponse>(url, form_data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  }

  async read(id: string | number) {
    const url = `${this.base_path}/${id}/read`;

    await this.http_client.patch(url);
  }
}
